// this script was provided by GloveFit
import { jsx as _jsx } from "react/jsx-runtime";
const SCRIPT_CONTENT = `
    var aid = "3872da8e-3211-11ef-b136-0affd97e338d";
    var url = encodeURIComponent(window.location.href);
    fetch("https://console.glove.fit/api/general/tagurl?aid=" + aid + "&url=" + url)
    .then(response => response.json())
    .then(data => {
        if(data.status === 'ok') {
            const script = document.createElement('script');
            script.async = true;  // This sets the async attribute
            script.src = data.url;
            document.head.appendChild(script);
        }
    })
    .catch(error => console.error('Error fetching the script URL:', error));
  `;
const GloveScript = ()=>{
    return /*#__PURE__*/ _jsx("script", {
        dangerouslySetInnerHTML: {
            __html: SCRIPT_CONTENT
        }
    });
};
export default GloveScript;
